import { render } from "./IconChevronRightFilled.vue?vue&type=template&id=4c04bd5c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronRightFilled.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c04bd5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c04bd5c', __exports__)) {
    api.reload('4c04bd5c', __exports__)
  }
  
  module.hot.accept("./IconChevronRightFilled.vue?vue&type=template&id=4c04bd5c", () => {
    api.rerender('4c04bd5c', render)
  })

}


export default __exports__